<template>
  <div class="Chart">
    <div class="Chart-top" id="Chart-top" style="width:100%;height:100%;"></div>
    <!-- <div
      class="Chart-buttom"
      id="Chart-buttom"
      style="width: 100%; height: 44%"
    ></div> -->
  </div>
</template>

<script>
export default {
  props: {
    hzsCount: {
      type: Array,
      default: [],
    },
    jtncCount: {
      type: Array,
      default: [],
    },
    ltqyCount: {
      type: Array,
      default: [],
    },
    zydhCount: {
      type: Array,
      default: [],
    },

    series: {
      type: Array,
      default: [],
    },
    source2: {
      type: Array,
      default: [],
    },
    legend2: {
      type: Array,
      default: [],
    },
    titleList: {
      type: Array,
      default: [],
    },
    // radius2: {
    //   type: [Array, Number],
    //   default: ["85%", "100%"],
    // },
  },
  watch: {
    // hzsCount(val) {
    //   if (val) {
    //     this.initChart();
    //   }
    // },
    source2(val){
      if (val) {
        let sum = 0;
        val.forEach(item=>{
          sum+= item.value
        })
        this.totalNum = sum;
        this.initChart2();
      }
    }
  },
  data() {
    return {
      chart: null,
      chart2: null,
      radius2: ["65%", "80%"],
      totalNum: 0,
    };
  },
  mounted() {},
  methods: {
    // initChart() {
    //   let that = this
    //   this.chart = this.$echarts.init(document.getElementById("Chart-buttom"));
    //   let arr = [];
    //   this.hzsCount.forEach((item,index)=>{
    //     arr.push((item-0)+(this.jtncCount[index]-0))
    //   })
    //   let maxNum = Math.max(...arr);
    //   let maxYaxisNum = maxNum&&maxNum>=5 ? maxNum : 5;
    //   // let maxHzsCount = Math.max(...this.hzsCount) || 0;
    //   // let maxJtncCount = Math.max(...this.jtncCount) || 0;
    //   // let maxNum = maxHzsCount>maxJtncCount? maxHzsCount : maxJtncCount;
    //   let options = {
    //       color: ["#188DF0", "#F9A031"],
    //       tooltip: {
    //         trigger: "axis",
    //         axisPointer: {
    //           // 坐标轴指示器，坐标轴触发有效
    //           type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
    //         },
    //         formatter: function (param) {
    //           console.log("param",param)
    //           if (param.length === 2 && (param[0].value||param[1].value)) {
    //               return (
    //                 param[0].name +
    //                 "<br/>" +
    //                 '合作社：' +
    //                 param[0].value +
    //                 // ": " +
    //                 // param[0].data.value +
    //                 "</br>" +
    //                 "家庭农场：" +
    //                 param[1].value
    //               );
    //             }
    //         },
    //       },
    //       grid: {
    //         left: "3%",
    //         right: "4%",
    //         bottom: "14%",
    //         top: '8%',
    //         containLabel: true,
    //       },
    //       xAxis: [
    //         {
    //           show: maxNum>0,
    //           type: "category",
    //           data: this.titleList,
    //           axisTick: {
    //             alignWithLabel: true,
    //           },
    //           axisLine: {
    //             lineStyle: {
    //               // color:"#fff",
    //               width: 1,
    //               show: false,
    //             },
    //           },
    //           splitLine: {
    //             show: false,
    //             lineStyle: {
    //               type: "dashed",
    //             },
    //           },
    //           axisTick: {
    //             //y轴刻度线
    //             show: false,
    //           },
    //            axisLabel: {
    //             interval:0,
    //             rotate:40
    //           }
    //         },
    //       ],
    //       yAxis: [
    //         {

    //           show: maxNum>0,
    //           type: "value",
    //           // minInterval: 1,
    //           splitNumber: maxYaxisNum>5?5:1,
    //           max:maxYaxisNum,
    //           axisLine: {
    //             lineStyle: {
    //               // color:"#fff",
    //               width: 0,
    //               show: false,
    //             },
    //             splitLine: {
    //               show: false,
    //               lineStyle: {
    //                 type: "dashed",
    //               },
    //             },
    //           },
    //         },
    //       ],
    //       series: [
    //         {
    //           name: "",
    //           type: "bar",
    //           barWidth: 12,
    //           stack: "总量",
    //           label: {
    //             show: true,
    //             position: "insideRight",
    //           },
    //           data: this.hzsCount,
    //         },
    //         {
    //           name: "",
    //           type: "bar",
    //           stack: "总量",
    //           label: {
    //             show: true,
    //             position: "insideRight",
    //           },
    //           //
    //           barWidth: 12,
    //           data:this.jtncCount,
    //         }
    //       ],
    //     }
    //   this.chart.setOption(
    //     options,
    //     true
    //   );
    //   // window.onresize = this.chart.resize;
    //   window.addEventListener("resize", this.chart.resize);
    // },
    initChart2() {
      let that = this;
      this.chart2 = this.$echarts.init(document.getElementById("Chart-top"));

      const legend_rich = {
        a: {
          fontSize: 14,
          color: '#fff',
          width: 100,
          align: 'left',
          padding: [0, 0, 0, 10],
        },

        b: {
          fontSize: 14,
          fontWeight: 'normal',
          color: '#fff',
          align: 'right',
          padding: [0, 0, 0, 10],
          lineHeight: 25,
        },
      }

      const color_arr = [
        "#f99b79",
        "#ff4500",
        "#ff8c00",
        "#1e90ff",
      ]

      // const total = that.source2.reduce((total, item) => {
      //   return total + item.value
      // }, 0)

      let options =
        {
          color: color_arr,
          legend: {
            show: true,
            right: 0,
            top: 'center',
            itemWidth: 10,
            itemHeight: 10,
            icon: 'circle',
            width: 150,

            textStyle: {
              color: 'auto',
              rich: legend_rich,
              fontWeight: 'normal'
            },

            formatter: function (name){
              if (!name) {
                return ''
              }
              let cur_item = that.source2 && that.source2.find(item => {
                return item.name == name
              })

              const scale = isNaN(cur_item.value / that.totalNum) ? 0 : (cur_item.value * 100 / that.totalNum).toFixed(2)

              return  '{a|'+ name +'} {b|' + cur_item.value + "个" + '\xa0' + '\xa0' + scale + "%" + '}'
            },
          },
          title: [
            {
              // text: that.GLOBAL.unitConversionSplit(that.totalNum).val+that.GLOBAL.unitConversionSplit(that.totalNum).unit + "人",
              text: that.totalNum + '家',
              left: "24%",
              top: "35%",
              textStyle: {
                fontSize: 24,
                color: "#00ffff",
                fontWeight: "800",
              },
            },
            {
              text: "主体数量",
              left: '23%',
              top: '50%',
              textStyle: {
                fontSize: 16,
                color: "#fff",
                fontWeight: "normal",
              },
            },
          ],
          // title:{
          //   text: total+'家',
          //   subtext: '主体数量',
          //   left: "39%",
          //   top: "38%",
          //   textAlign: "center",
          //   textStyle: {
          //     color: "#333",
          //     fontSize: 18,
          //   },
          //   subtextStyle:{
          //     color: "#333",
          //     fontSize: 14,
          //   },
          // },
          tooltip: {
            trigger: "item",
            backgroundColor: 'rgba(255,255,255,0.15)',
            borderColor: '#00D7FE',
            textStyle: {
              color: 'white',
              fontSize: 14,
              fontWeight: 'normal'
            },
            formatter: "{b}<br/> 数量：{c} <br/> 占比：{d}%",
            // formatter: function (value) {
            //   let data = value.data
            //   return (
            //     data.name +
            //     "<br/>" +
            //     "数量：" +
            //     data.value +
            //     "<br/>" +
            //     "占比：" +
            //     data.scale + '%'
            //   );
            // },
            type: "pie",
          },
          // tooltip: {
          //   trigger: "item",
          //   formatter: "{b}<br/> 数量：{c} <br/> 占比：{d}%",
          // },
          // legend: {
          //   orient: "vertical", //horizontal
          //   right: 20,
          //   bottom: "center",
          //   data: this.legend2,
          // },
          // series: [
          //   {
          //     name: "",
          //     type: "pie",
          //     radius: this.radius2,
          //     center: ["40%", "50%"],
          //     avoidLabelOverlap: false,
          //     label: {
          //       normal:{
          //         show: false,
          //       },
          //       position: "center",
          //     },
          //     emphasis: {
          //       label: {
          //         show: true,
          //         fontSize: "30",
          //         fontWeight: "bold",
          //       },
          //     },
          //     labelLine: {
          //       show: false,
          //     },
          //     data: this.source2,
          //     itemStyle: {
          //       normal: {
          //         color: function (params) {
          //           //自定义颜色
          //           var colorList = ["#2E99FF", "#F89E01",'#0EAF70','#9D7EFF'];
          //           return colorList[params.dataIndex];
          //         },
          //       },
          //     },
          //   },
          // ],
          series: [
            {
              type: "pie",
              radius: ['60%', '75%'],
              center: ['30%', '50%'],
              hoverAnimation: false,
              avoidLabelOverlap: false,
              label: {
                normal: {
                  show: false,
                  position: 'center'
                },
                emphasis: {
                  show: false
                },
              },
              emphasis: {
                label: {
                  show: false,
                  fontSize: '40',
                  fontWeight: 'bold'
                }
              },
              lableLine: {
                normal: {
                  show: false
                },
                emphasis: {
                  show: false
                }
              },
              data: that.source2,
            },
            {
              type: 'pie',
              radius: ['52%', '65%'],
              center: ['30%', '50%'],
              hoverAnimation: false,
              avoidLabelOverlap: false,
              itemStyle: {
                opacity: 0.6,
              },
              label: {
                normal: {
                  show: false,
                  position: 'center'
                },
                emphasis: {
                  show: false
                },
              },
              emphasis: {
                label: {
                  show: false,
                  fontSize: '40',
                  fontWeight: 'bold'
                }
              },
              lableLine: {
                normal: {
                  show: false
                },
                emphasis: {
                  show: true
                }
              },
              data: that.source2,
            },
            {//内部虚线圆环
              name: 'decorationOne',
              type: 'pie',
              color: ['rgba(255,255,255,0.2)', 'rgba(255,255,255,0)'],
              radius: ['46%', '48%'],
              center: ['30%', '50%'],
              hoverAnimation: false,
              itemStyle: {
                opacity: 0.8,
              },
              label: {
                normal: {
                  show: false,
                  position: 'center'
                },
                emphasis: {
                  show: false
                },
              },
              emphasis: {
                label: {
                  show: false,
                  fontSize: '40',
                  fontWeight: 'bold'
                }
              },
              lableLine: {
                normal: {
                  show: false
                },
                emphasis: {
                  show: true
                }
              },
              silent: true,
              tooltip: {
                show: false,
              },
              data: new Array(100).fill(10).map(() => {
                return {
                  name: '',
                  value: 20,
                };
              }),
            },
          ],
        }

      setTimeout(() => {
        that.chart2.setOption(options);
        // this.pieChart.setOption(this.myOption);
        that.chart2.resize();
        window.addEventListener("resize", that.chart2.resize);
      }, 300);
      // window.onresize = this.chart2.resize;
      // window.addEventListener("resize", this.chart2.resize);
    },
  },
};
</script>

<style lang="less" scoped>
.Chart {
  height: calc(100% - 40px);
  .Chart-top{
    height: 100%;
  }
  // .Chart-buttom {
  //   height: 44%;
  // }
}
</style>



// WEBPACK FOOTER //
// src/studio/homepage/home/homerighttop.vue